import Schedule from './Schedule.container'
export default Schedule
